export const SPRAY_EVENT_TYPE_SET = 'SPRAY_EVENT_TYPE_SET';
export const SPRAY_EVENT_TYPE_WEED = 'WEED_SPRAY';
export const SPRAY_EVENT_TYPE_CROP = 'CROP_SPRAY';
